import React, { useEffect, useRef, useState, Fragment } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';

import './agriculture-modal.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faAdd,
  faCircleXmark,
  // faCloudUploadAlt,
  faFilePdf,
  faMinus,
  faXmark,
  faLink,
} from '@fortawesome/free-solid-svg-icons';
import {
  IconButton,
  FormControlLabel,
  Radio,
  FormLabel,
  RadioGroup,
  FormControl,
  TextField,
  FormGroup,
  Switch,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

import ButtonUI from '../../../../components/ui/button/button';
import FieldsetUI from '../../../../components/ui/fieldset/fieldset';
import PreviewImageUI from '../../../../components/ui/preview-image/preview-image';
import SwalUI from '../../../../components/ui/swal-ui/swal-ui';
import { svUpdateProduct } from '../../../../services/productServices/pageagriculture.service';
// import CKeditorComponent from '../../../../components/ui/ckeditor/ckeditor';

function AgricultureEditMpdal(props) {
  const { t, isEdit, isOpen, category, items } = props;

  const thumbnailDefault = {
    thumbnail: true,
    src: '',
    file: null,
    name: null,
    remove: false,
  };

  const [isError, setIsError] = useState({
    thumbnail: false,
    thumbnail_slides: false,
    category: false,
    title: false,
    segment: false,
    plant1: false,
    plant2: false,
    plant3: false,
    fruit1: false,
    fruit2: false,
    fruit3: false,
    taste1: false,
    taste2: false,
    disease1: false,
    disease2: false,
  });

  const [editData, setEditData] = useState({
    id: items.id,
    category: items.category || '',
    // imageName:items.thumbnail_link,
    thumbnail_link: items.thumbnail_link || '',
    thumbnail_title: items.thumbnail_title || '',
    thumbnail_alt: items.thumbnail_alt || '',
    thumbnailSlides_name: items.thumbnail_second_link || '',
    thumbnailSlides_title: items.thumbnail_second_title || '',
    thumbnailSlides_alt: items.thumbnail_second_alt || '',
    seement: items.seement || '',
    title: items.title || '',
    plant1: items.plant_1 || '',
    plant2: items.plant_2 || '',
    plant3: items.plant_3 || '',
    fruit1: items.fruit_1 || '',
    fruit2: items.fruit_2 || '',
    fruit3: items.fruit_3 || '',
    taste1: items.taste_1 || '',
    taste2: items.taste_2 || '',
    disease1: items.disease_1 || '',
    disease2: items.disease_2 || '',
    link_youtube: items.link_youtube || '',
    doc_link: items.doc_link || '',
    display: items.display,
    pin: items.pin,
    priority: items.priority,
    language: items.language,
  });

  const uploadPath = useSelector((state) => state.app.uploadPath);
  const language = useSelector((state) => state.app.language);

  const [previews, setPreviews] = useState(thumbnailDefault);
  const [previewsSecond, setPreviewsSecond] = useState(thumbnailDefault);
  const [fileDoc, setFileDoc] = useState(null);
  const [fileName, setFileName] = useState('');

  const [isFetching, setIsFetching] = useState(false);
  const [tegegmentList, setTegegmentList] = useState([]);
  const scrollRef = useRef(null);
  const textInputDoc = t('textInputDoc');
  const inpFile = useRef();
  const titleFile = useRef();

  useEffect(() => {
    /* Set thumbnail */
    let thumbnail = uploadPath + items.thumbnail_link;
    setPreviews({
      file: null,
      src: thumbnail,
      remove: true,
      srcDefault: thumbnail,
    });
    /* Set thumbnailSecond */
    let thumbnailSecond = uploadPath + items.thumbnail_second_link;
    setPreviewsSecond({
      file: null,
      src: thumbnailSecond,
      remove: true,
      srcDefault: thumbnailSecond,
    });

    let seementSelect = category.filter(
      (item) => String(item.id) === String(items.category)
    );
    console.log(seementSelect);
    setTegegmentList(seementSelect[0].segments_data);
  }, [items, uploadPath, category]);

  const setPreviewHandler = (data) => {
    setEditData({
      ...editData,
      thumbnail_link: data.file ? data.file.name : '',
    });
    setPreviews(data);
  };

  const setPreviewSecondHandler = (data) => {
    setEditData({
      ...editData,
      thumbnailSlides_name: data.file ? data.file.name : '',
    });
    setPreviewsSecond(data);
  };

  const uploadPreview = (e) => {
    const file = e.target.files[0];
    e.value = null;
    setFileDoc(file);
    // setFileName(file.name.split('.')[0] + language)
    setEditData((prevState) => {
      return { ...prevState, doc_link: file.name.split('.')[0] + language };
    });

    let fileSize = parseFloat(file.size / (1024 * 1024)).toFixed(2);
    titleFile.current.textContent = `${file.name} (${fileSize}mb)`;
  };

  const onResetFileDoc = () => {
    setFileDoc(null);
    setFileName('');
    inpFile.current.value = '';
    titleFile.current.textContent = textInputDoc;
  };

  const priorityHandler = (isAdding) => {
    if (isAdding) {
      setEditData((prevState) => {
        return { ...prevState, priority: parseInt(editData.priority) + 1 };
      });
    } else if (parseInt(editData.priority) > 1) {
      setEditData((prevState) => {
        return { ...prevState, priority: parseInt(editData.priority) - 1 };
      });
    }
  };

  const editValidators = () => {
    let isValid = true;

    let error = {
      ...isError,
      thumbnail: editData.thumbnail_link.trim().length < 1,
      thumbnail_slides: editData.thumbnailSlides_name.trim().length < 1,
      // segment: editData.seement.trim() === '',
      title: editData.title.trim().length < 1,
      plant1: editData.plant1.trim().length < 1,
      plant2: editData.plant2.trim().length < 1,
      plant3: editData.plant3.trim().length < 1,
      fruit1: editData.fruit1.trim().length < 1,
      fruit2: editData.fruit2.trim().length < 1,
      fruit3: editData.fruit3.trim().length < 1,
      taste1: editData.taste1.trim().length < 1,
      taste2: editData.taste2.trim().length < 1,
      disease1: editData.disease1.trim().length < 1,
      disease2: editData.disease2.trim().length < 1,
    };

    setIsError(() => error);
    const hasError = Object.values(error).find((err) => err === true);
    if (hasError) isValid = false;

    if (isValid) {
      const embed_url = editData.link_youtube.replace('/watch?v=', '/embed/');

      const formData = new FormData();
      if (previews.file) {
        formData.append('Image', previews.file);
      }
      if (previewsSecond.file) {
        formData.append('ImageSecond', previewsSecond.file);
      }
      if (fileDoc) {
        formData.append('pdf', fileDoc);
        formData.append('pdfName', fileName);
      }
      formData.append('thumbnail_link', editData.thumbnail_link);
      formData.append('thumbnail_title', editData.thumbnail_title);
      formData.append('thumbnail_alt', editData.thumbnail_alt);
      formData.append('thumbnail_second_link', editData.thumbnailSlides_name);
      formData.append('thumbnail_second_title', editData.thumbnailSlides_title);
      formData.append('thumbnail_second_alt', editData.thumbnailSlides_alt);

      formData.append('docLink', editData.doc_link);

      formData.append('id', editData.id);
      // formData.append("keyword", editData.keyword);
      // formData.append('slug', editData.slug);
      formData.append('title', editData.title);
      formData.append('category', editData.category);
      // formData.append('description', ckValue);
      formData.append('seement', editData.seement);
      formData.append('PlantLine1', editData.plant1);
      formData.append('PlantLine2', editData.plant2);
      formData.append('PlantLine3', editData.plant3);
      formData.append('FruitLine1', editData.fruit1);
      formData.append('FruitLine2', editData.fruit2);
      formData.append('FruitLine3', editData.fruit3);
      formData.append('TasteLine1', editData.taste1);
      formData.append('TasteLine2', editData.taste2);
      formData.append('DiseaseLine1', editData.disease1);
      formData.append('DiseaseLine2', editData.disease2);
      formData.append('linkYoutub', embed_url);
      // formData.append("link_facebook", editData.link_facebook);
      // formData.append("link_twitter", editData.link_twitter);

      formData.append('display', editData.display ? 1 : 0);
      formData.append('pNew', editData.pin ? 1 : 0);
      formData.append('priority', editData.priority);
      formData.append('language', isEdit ? editData.language : language);

      for (var pair of formData.entries()) {
        console.log(pair[0] + ', ' + pair[1]);
      }
      // return false;

      saveHandler(formData);
    } else {
      scrollToTop();
    }
  };

  const scrollToTop = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const saveHandler = (formData) => {
    setIsFetching(true);
    setIsFetching(false);

    svUpdateProduct(editData.id, formData).then((res) => {
      setIsFetching(false);
      if (res.status === 200) {
        props.setClose({
          isEdit: false,
          isOpen: false,
        });
        SwalUI({ status: res.data.status, description: res.data.description });
        props.setRefreshData((prev) => prev + 1);
      } else {
        SwalUI({ status: res.data.status, description: res.data.description });
      }
    });
  };

  const segmentHandleChange = (event) => {
    let seementSelect = tegegmentList.filter(
      (item) => item.id === event.target.value
    );
    // console.log(seementSelect);
    setEditData(() => {
      return {
        ...editData,
        // title: seementSelect[0].title,
        seement: event.target.value,
      };
    });
  };
  //  console.log(props);
  return (
    <Fragment>
      <Modal
        disableEnforceFocus
        open={isOpen}
        onClose={() =>
          props.setClose({
            isEdit: false,
            isOpen: false,
          })
        }
        className={'modal-edit-agriculture'}
        aria-labelledby="modal-edit-agriculture"
        aria-describedby="modal-edit-agriculture"
      >
        <Box className="modal-custom">
          <div className="modal-header">
            <h2>
              <FontAwesomeIcon icon={faEdit} />
              <span>{t('ModalEditProduct')}</span>
            </h2>
            <IconButton
              className="param-generator"
              color="error"
              sx={{ p: '10px' }}
              onClick={() =>
                props.setClose({
                  isEdit: false,
                  isOpen: false,
                })
              }
            >
              <FontAwesomeIcon icon={faXmark} />
            </IconButton>
          </div>

          <div className="modal-body overflow-scroll-custom">
            <fieldset className="modal-fieldset">
              <div
                className={`box-checkbox-container cate-menu-list
               
              ${isError.category ? 'error' : ''}`}
              >
                <div className="brc-body overflow-scroll-custom">
                  {/* RadioBoxUI */}
                  <FormControl className="brc-form-control">
                    <FormLabel id="box-checkbox">{t('Category')}</FormLabel>
                    <RadioGroup
                      aria-labelledby="box-checkbox"
                      name="controlled-checkbox-buttons-group"
                    >
                      {category &&
                        category.map((item) => {
                          return (
                            <FormControlLabel
                              key={item.id}
                              onChange={(e) => {
                                setTegegmentList(item.segments_data);
                                setEditData((prevState) => {
                                  return {
                                    ...prevState,
                                    category: e.target.value,
                                  };
                                });
                              }}
                              checked={
                                parseInt(item.id) ===
                                parseInt(editData.category)
                                  ? true
                                  : false
                              }
                              value={item.id}
                              control={<Radio />}
                              label={item.title}
                            />
                          );
                        })}
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
              <div className="form-details">
                <div className="image-box">
                  {/* รูป 1*/}

                  <FieldsetUI
                    className={`image-setting ${
                      isError.thumbnail ? 'error' : ''
                    }`}
                    label={t('รูปผล')}
                    label2={'750*590 px'}
                  >
                    <PreviewImageUI
                      className="edit-image"
                      previews={previews}
                      setPreviews={setPreviewHandler}
                      setData={setEditData}
                    />
                    <div className="image-detail">
                      {previews.file && (
                        <TextField
                          onChange={(e) =>
                            setEditData((prevState) => {
                              return {
                                ...prevState,
                                thumbnail_link: e.target.value,
                              };
                            })
                          }
                          value={editData.thumbnail_link}
                          className={`text-field-custom ${
                            !previews.file ? 'inp-hidden' : ''
                          }`}
                          fullWidth={true}
                          error={false}
                          id="image-name"
                          label={t('ModalImageName')}
                          size="small"
                        />
                      )}
                      <TextField
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return {
                              ...prevState,
                              thumbnail_title: e.target.value,
                            };
                          })
                        }
                        value={editData.thumbnail_title}
                        className="text-field-custom"
                        fullWidth={true}
                        error={false}
                        id="image-title"
                        label={t('ModalImageTitle')}
                        size="small"
                      />
                      <TextField
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return {
                              ...prevState,
                              thumbnail_alt: e.target.value,
                            };
                          })
                        }
                        value={editData.thumbnail_alt}
                        className="text-field-custom"
                        fullWidth={true}
                        error={false}
                        id="image-tag"
                        label={t('ModalAltDescription')}
                        size="small"
                      />
                    </div>
                  </FieldsetUI>
                  {/* รูป 2*/}
                  <FieldsetUI
                    className={`image-setting ${
                      isError.thumbnail ? 'error' : ''
                    }`}
                    label={t('รูปต้น')}
                    label2={'750*590 px'}
                  >
                    <PreviewImageUI
                      className={`edit-imageSecond ${
                        isError.thumbnail_slides ? 'error' : ''
                      }`}
                      previews={previewsSecond}
                      setPreviews={setPreviewSecondHandler}
                      setData={setEditData}
                      inputFileStyle={{
                        border: isError.imageInfo ? '1px solid red' : '',
                      }}
                    />
                    <div className="image-detail">
                      {previewsSecond.file && (
                        <TextField
                          onChange={(e) =>
                            setEditData((prevState) => {
                              return {
                                ...prevState,
                                thumbnailSlides_name: e.target.value,
                              };
                            })
                          }
                          value={editData.thumbnailSlides_name}
                          className="text-field-custom"
                          fullWidth={true}
                          error={isError.thumbnailSlides_name}
                          id="image-name"
                          label="ImageSecond name"
                          size="small"
                        />
                      )}
                      <TextField
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return {
                              ...prevState,
                              thumbnailSlides_title: e.target.value,
                            };
                          })
                        }
                        value={editData.thumbnailSlides_title}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.thumbnailSlides_title}
                        id="image-title"
                        label="ImageSecond title"
                        size="small"
                      />
                      <TextField
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return {
                              ...prevState,
                              thumbnailSlides_alt: e.target.value,
                            };
                          })
                        }
                        value={editData.thumbnailSlides_alt}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.thumbnailSlides_alt}
                        id="image-tag"
                        label="ImageSecond description"
                        size="small"
                      />
                    </div>
                  </FieldsetUI>
                </div>
                {/* รายละเอียด */}
                <div className="category-details">
                  <h3 className="category-detail-title">{t('ModalDetail')}</h3>
                  {/* <div className="input-half">
                  <TextField
                    onChange={(e) =>
                      setEditData((prevState) => {
                        return { ...prevState, keyword: e.target.value };
                      })
                    }
                    value={editData.keyword}
                    className="text-field-custom"
                    fullWidth={true}
                    error={isError.keyword}
                    id="ed-keyword"
                    label={t("ModalCategoriesName")}
                    size="small"
                  />
                </div> */}
                  {/* <div className="input-full">
                  <TextField
                    onChange={(e) =>
                      setEditData((prevState) => {
                        return { ...prevState, slug: e.target.value };
                      })
                    }
                    value={editData.slug}
                    className="text-field-custom"
                    fullWidth={true}
                    error={isError.slug}
                    id="ed-slug"
                    label={t("ModalCategorieskeyword")}
                    size="small"
                  />
                </div> */}
                  {/* segment */}
                  <div className="input-half">
                    <FormControl
                      sx={{ width: '100%', marginTop: '12px' }}
                      size="small"
                      error={isError.segment}
                    >
                      <InputLabel id="demo-select-small-label">
                        segment
                      </InputLabel>
                      <Select
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        value={editData.seement}
                        label="segment"
                        onChange={segmentHandleChange}
                      >
                        {tegegmentList.map((e) => {
                          return (
                            <MenuItem key={e.id} value={e.id}>
                              {e.title}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    {/* <TextField
                      onChange={(e) =>
                        setEditData((prevState) => {
                          return { ...prevState, seement: e.target.value };
                        })
                      }
                      value={editData.seement}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.seement}
                      id="ad-seement"
                      label={t("seement")}
                      size="small"
                    /> */}
                  </div>
                  {/* title */}
                  <div className="input-half">
                    <TextField
                      onChange={(e) =>
                        setEditData((prevState) => {
                          return { ...prevState, title: e.target.value };
                        })
                      }
                      value={editData.title}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.title}
                      id="ed-title"
                      label={t('ModalCategorieskeyword')}
                      size="small"
                    />
                  </div>
                  {/* plant */}
                  <FieldsetUI className="plant-group " label={'plant'}>
                    <div className="group-detail">
                      <TextField
                        id="outlined-basic"
                        label="line-1"
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return { ...prevState, plant1: e.target.value };
                          })
                        }
                        value={editData.plant1}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.plant1}
                      />
                      <TextField
                        id="outlined-basic"
                        label="line-2"
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return { ...prevState, plant2: e.target.value };
                          })
                        }
                        value={editData.plant2}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.plant2}
                      />
                      <TextField
                        id="outlined-basic"
                        label="line-3"
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return { ...prevState, plant3: e.target.value };
                          })
                        }
                        value={editData.plant3}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.plant3}
                      />
                    </div>
                  </FieldsetUI>
                  {/* fruit */}
                  <FieldsetUI className="plant-group " label={'fruit'}>
                    <div className="group-detail">
                      <TextField
                        id="outlined-basic"
                        label="line-1"
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return { ...prevState, fruit1: e.target.value };
                          })
                        }
                        value={editData.fruit1}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.fruit1}
                      />
                      <TextField
                        id="outlined-basic"
                        label="line-2"
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return { ...prevState, fruit2: e.target.value };
                          })
                        }
                        value={editData.fruit2}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.fruit2}
                      />
                      <TextField
                        id="outlined-basic"
                        label="line-3"
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return { ...prevState, fruit3: e.target.value };
                          })
                        }
                        value={editData.fruit3}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.fruit3}
                      />
                    </div>
                  </FieldsetUI>
                  {/* taste */}
                  <FieldsetUI className="plant-group " label={'taste'}>
                    <div className="group-detail">
                      <TextField
                        id="outlined-basic"
                        label="line-1"
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return { ...prevState, taste1: e.target.value };
                          })
                        }
                        value={editData.taste1}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.taste1}
                      />
                      <TextField
                        id="outlined-basic"
                        label="line-2"
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return { ...prevState, taste2: e.target.value };
                          })
                        }
                        value={editData.taste2}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.taste2}
                      />
                    </div>
                  </FieldsetUI>
                  {/* disease */}
                  <FieldsetUI className="plant-group " label={'disease'}>
                    <div className="group-detail">
                      <TextField
                        id="outlined-basic"
                        label="line-1"
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return {
                              ...prevState,
                              disease1: e.target.value,
                            };
                          })
                        }
                        value={editData.disease1}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.disease1}
                      />
                      <TextField
                        id="outlined-basic"
                        label="line-2"
                        onChange={(e) =>
                          setEditData((prevState) => {
                            return {
                              ...prevState,
                              disease2: e.target.value,
                            };
                          })
                        }
                        value={editData.disease2}
                        className="text-field-custom"
                        fullWidth={true}
                        error={isError.disease2}
                      />
                    </div>
                  </FieldsetUI>
                  <div className="input-full">
                    <TextField
                      onChange={(e) =>
                        setEditData((prevState) => {
                          return { ...prevState, link_youtube: e.target.value };
                        })
                      }
                      value={editData.link_youtube}
                      className="text-field-custom"
                      fullWidth={true}
                      error={false}
                      id="ed-linkyoutube"
                      label={t('Link Youtube')}
                      size="small"
                    />
                  </div>
                  <div className="input-full">
                    <input
                      type="file"
                      className="input-file"
                      ref={inpFile}
                      accept="*/*"
                      onChange={uploadPreview}
                    />
                    <div className="select-doc">
                      {editData.doc_link && (
                        <a
                          href={uploadPath + editData.doc_link}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <ButtonUI
                            loader={false}
                            icon={<FontAwesomeIcon icon={faLink} />}
                            className="btn-save"
                            on="save"
                            width="free"
                            onClick={() => console.log('clicked')}
                          >
                            {t('ดูเอกสารเดิม')}
                          </ButtonUI>
                        </a>
                      )}
                      <ButtonUI
                        loader={false}
                        icon={<FontAwesomeIcon icon={faFilePdf} />}
                        className="btn-save"
                        on="add"
                        width="free"
                        onClick={() => inpFile.current.click()}
                      >
                        {t('Selectdocument')}
                      </ButtonUI>
                      <div className="fileName" ref={titleFile}>
                        {' '}
                        {textInputDoc}
                      </div>
                      <button onClick={onResetFileDoc}>
                        {fileDoc && (
                          <FontAwesomeIcon
                            icon={faCircleXmark}
                            style={{ color: '#ff0000' }}
                          />
                        )}
                      </button>
                    </div>
                  </div>
                  {/*<div className="input-full">
                    <TextField
                      onChange={(e) =>
                        setEditData((prevState) => {
                          return { ...prevState, link_twitter: e.target.value };
                        })
                      }
                      value={editData.link_twitter}
                      className="text-field-custom"
                      fullWidth={true}
                      error={false}
                      id="ed-Link Twitter"
                      label={t("Link Twitter")}
                      size="small"
                    />
                  </div>*/}
                  {/* Settings */}
                  <div className="group-settings">
                    <h3 className="post-detail-titile">{t('Settings')}</h3>
                    <div className="setting-controls">
                      <div className="switch-form">
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    display: e.target.checked,
                                  })
                                }
                                checked={editData.display ? true : false}
                              />
                            }
                            label={t('display')} //การแสดงผล
                            labelPlacement="start"
                          />
                        </FormGroup>
                      </div>
                      <div className="switch-form">
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    pin: e.target.checked,
                                  })
                                }
                                checked={editData.pin ? true : false}
                              />
                            }
                            label={t('New')}
                            labelPlacement="start"
                          />
                        </FormGroup>
                      </div>
                      <div className="input-group-settings">
                        <div className="inp">
                          <ButtonUI
                            color="error"
                            onClick={(e) => priorityHandler(false)}
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </ButtonUI>
                          <span className="title">
                            {t('Priority')} {editData.priority}
                          </span>
                          <ButtonUI onClick={(e) => priorityHandler(true)}>
                            <FontAwesomeIcon icon={faAdd} />
                          </ButtonUI>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="modal-footer">
            {/* ปุ่ม */}
            <ButtonUI
              loader={true}
              isLoading={isFetching}
              className="btn-save"
              on="save"
              width="md"
              onClick={editValidators}
            >
              {t('Save')}
            </ButtonUI>
            <ButtonUI
              className="btn-cancel"
              on="cancel"
              width="md"
              onClick={() =>
                props.setClose({
                  isEdit: false,
                  isOpen: false,
                })
              }
            >
              {t('Cancel')}
            </ButtonUI>
          </div>
        </Box>
      </Modal>
    </Fragment>
  );
}

export default AgricultureEditMpdal;
